var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetIntakes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Target_intakes",
    "data-name": "Target intakes",
    transform: "translate(-15281 -7759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516",
    width: 30,
    height: 30,
    transform: "translate(15281 7759)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bullseye",
    transform: "translate(15243.896 7764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15807",
    "data-name": "Group 15807",
    transform: "translate(42.105 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5255",
    "data-name": "Path 5255",
    d: "M230.26,169.968a1.328,1.328,0,1,0-1.328-1.328A1.33,1.33,0,0,0,230.26,169.968Z",
    transform: "translate(-220.668 -159.11)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5256",
    "data-name": "Path 5256",
    d: "M150.184,95.446a5.442,5.442,0,0,0,5.46-5.411c-.274-7.168-10.648-7.166-10.92,0A5.442,5.442,0,0,0,150.184,95.446Zm0-8.215a2.8,2.8,0,1,1-2.8,2.8A2.807,2.807,0,0,1,150.184,87.231Z",
    transform: "translate(-140.592 -80.506)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5257",
    "data-name": "Path 5257",
    d: "M339.035,374.718l.235.876h3.056l-.638-2.383A11.067,11.067,0,0,1,339.035,374.718Z",
    transform: "translate(-325.369 -354.898)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5258",
    "data-name": "Path 5258",
    d: "M108.97,375.595l.235-.875a11.068,11.068,0,0,1-2.652-1.507l-.638,2.383h3.055Z",
    transform: "translate(-103.687 -354.899)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5259",
    "data-name": "Path 5259",
    d: "M70.106,19.122A9.6,9.6,0,0,0,79.7,9.53c-.482-12.708-18.7-12.7-19.184,0A9.6,9.6,0,0,0,70.106,19.122Zm0-16.479A6.919,6.919,0,0,1,77.042,9.53c-.348,9.123-13.525,9.121-13.872,0A6.919,6.919,0,0,1,70.106,2.643Z",
    transform: "translate(-60.514 0)",
    fill: "#3f2765"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIntakes);
export default __webpack_public_path__ + "static/media/target-intakes.a878b5e729de2e6b9eeee0afd211a72e.svg";
export { ForwardRef as ReactComponent };